import apiService from "../service/api.service";

export const fetchUserProfile = async (token: string, userId: string) => {
	const profile = await apiService.MakeGetRequest(
		`/user/profile/${userId}`,
		token
	);
	return profile;
};
